import { Component } from '@angular/core';

@Component({
  selector: 'opac-cookies-overview',
  templateUrl: './cookies-overview.component.html',
  styleUrls: ['./cookies-overview.component.scss']
})
export class CookiesOverviewComponent { }